<template>
  <div class="subscription-switch">

    <AutoScroll />
    <PageBlock :title="$t('swithcing', { to: $t('tariffs.' + to.slug) })">
      <div v-html="$t('warning.' + fromToType, {
          period: $t('periods.' + to.period),
          expire: localizeNext,
          'less-more': lessMore,
        })"></div>
    </PageBlock>

    <TariffSwitchAction :from="from" :to="to" />
  </div>
</template>

<script>
import TariffSwitchAction from '@/views/user/TariffSwitchAction'
import PageBlock from '@/components/visual/PageBlock'
import AutoScroll from '@/components/visual/AutoScroll'

  export default {
    props: [ 'from', 'to' ],
    components: { TariffSwitchAction, PageBlock, AutoScroll },
    methods: {
      isFree(tariff) { return tariff.price == 0 },
      isPaidEndless(tariff) { return tariff.price > 0 && tariff.period == 'endless' },
      isPaidRenewable(tariff) { return tariff.price > 0 && tariff.period != 'endless' },
      isTrial(tariff) { return tariff.price == 0 && ! tariff.prolongable && tariff.period != 'endless'},
      isHidden(tariff) { return tariff.price == 0 && tariff.visible == false },
      getType(tariff) {
        if (this.isHidden(tariff)) return 'hiddden'
        if (this.isPaidEndless(tariff)) return 'paid-endless'
        if (this.isPaidRenewable(tariff)) return 'paid-renew'
        if (this.isTrial(tariff)) return 'trial'
        return 'free'
      },
    },
    computed: {
        fromToType() {
          return this.getType(this.from) + '-to-' + this.getType(this.to)
        },
        localizeNext() {
          return this.from.next_transaction_date 
            ? this.$d(new Date(this.from.next_transaction_date), 'short') : ''
        },
        lessMore() {
          if (this.from.period.includes('month') && (this.to.period.includes('year') || this.to.period.includes('endless')))
            return this.$t('more')
          if ((this.from.period.includes('endless') || this.from.period.includes('year')) && this.to.period.includes('month')
            || this.from.period.includes('endless') && this.to.period.includes('year'))
            return this.$t('less')
          if (this.from.period == this.to.period) 
            return (this.from.price > this.to.price) ? this.$t('more') : this.$t('less')
          return ''
        },
    },
  }
</script>

<i18n locale="ru" lang="yaml">
  swithcing: "Вы собираетесь сменить тарифный план на «{to}»"
  less: "менее"
  more: "более"
  warning:
    free-to-free: "За этот тарифный план вам не придется платить. <p>Посмотрите, какие возможности в нем добавятся, а какие исчезнут.</p>"

    free-to-trial: "На этом тарифном плане вы бесплатно можете попробовать и оценить платные возможности. Он будет активен только {period}. <p>Если до конца этого срока вы не решите перейти на платный тариф, то автоматически переключитесь на бесплатный.</p>"

    free-to-paid-renew: "Этот тарифный план открывает доступ к платным возможностям. <p>Подписка продлевается автоматически. Это значит, что вам нужно оплатить только первый {period}, а все следующие платежи будут автоматически списываться с карты, которую вы укажете при оплате.</p> <p>Вы сможете отменить подписку в любой момент у себя в профиле.</p>"

    free-to-paid-endless: "Этот тарифный план открывает доступ к платным возможностям. <p>Эта подписка не требует продления. Вы платите один раз и получаете пожизненный доступ ко всем возможностям.</p>"

    trial-to-free: "Вы собираетесь отменить пробный тарифный план. <p>Внимание! Все возможности текущего тарифного плана отключатся при переходе на новый.</p>"

    trial-to-paid-renew: "Этот тарифный план открывает доступ к платным возможностям. <p>Подписка продлевается автоматически. Это значит, что вам нужно оплатить только первый {period}, а все следующие платежи будут списываться с карты, которую вы укажете при оплате. <p>Действие платного тарифа начнется только после окончания пробного, то есть после {expire}</p> <p>Вы сможете отменить подписку в любой момент у себя в профиле.</p>"

    trial-to-paid-endless: "Этот тарифный план открывает доступ к платным возможностям. <p>Эта подписка не требует продления. Вы платите один раз и получаете пожизненный доступ ко всем возможностям.</p>"

    paid-renew-to-free: "Вы собираетесь отменить платный тарифный план. <p>Если вы отмените подписку, то все его возможности отключатся {expire} Деньги больше не будут списываться с вашей карты.</p>"

    paid-renew-to-paid-renew: "Вы собираетесь перейти на {less-more} выгодный тарифный план. <p>У вас уже есть предоплаченный период, который заканчивается {expire} Мы зачислим неиспользованный остаток в оплату нового тарифного плана.</p>"

    paid-renew-to-paid-endless: "Вы собираетесь перейти на {less-more} выгодный тарифный план. <p>У вас уже есть предоплаченный период, который заканчивается {expire} Мы зачислим неиспользованный остаток в оплату нового тарифного плана.</p>"

    paid-endless-to-free: "Вы собираетесь отменить платный тарифный план. <p>Если вы отмените подписку, то все его возможности отключатся навсегда.</p>"

    paid-endless-to-paid-renew: "Вы собираетесь перейти на {less-more} выгодный тарифный план. <p>У вас уже есть оплаченный тариф с пожизненным использованием. Если вы перейдете на новый тариф, то потеряете все преимущества пожизненного тарифа.</p>"

    paid-endless-to-paid-endless: "Вы собираетесь перейти на {less-more} выгодный тарифный план. <p>У вас уже есть оплаченный тариф с пожизненным использованием. Мы зачислим его стоимость в оплату нового тарифного плана.</p>"

    hidden-to-free: "За этот тарифный план вам не придется платить. <p>Внимание! Все возможности текущего тарифного плана отключатся при переходе на новый.</p>"

    hidden-to-trial: "На этом тарифном плане вы бесплатно можете попробовать и оценить платные возможности. <p>Он будет активен только {period}. Если до конца этого срока вы не решите перейти на платный тариф, то автоматически переключитесь на бесплатный.</p> <p>Внимание! Все возможности текущего тарифного плана отключатся при переходе на новый.</p>"

    hidden-to-paid-renew: "Этот тарифный план открывает доступ к платным возможностям. <p>Подписка продлевается автоматически. Это значит, что вам нужно оплатить только первый {period}, а все следующие платежи будут списываться с карты, которую вы укажете при оплате.</p> <p>Вы сможете отменить подписку в любой момент у себя в профиле.</p>"

    hidden-to-paid-endless: "Этот тарифный план открывает доступ к платным возможностям. <p>Эта подписка не требует продления. Вы платите один раз и получаете пожизненный доступ ко всем возможностям.</p>"
</i18n>

<i18n locale="en" lang="yaml">
  swithcing: "You are going to switch to \"{to}\""
</i18n>
